module.exports = __webpack_public_path__ + "img/s_whiteblackH-logo.3cb7a83.png";